import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { message } from "antd";

import { OthersAction, QuestionnaireAction } from "../../store/actions";

import {
  Buttons,
  Spacer,
  questionnaireComponents,
  inputFields,
  Loader,
} from "../../components";

import "./styles.css";

const Location = ({ setPage }) => {
  const dispatch = useDispatch();

  const profileData = useSelector((state) => state.profile?.user);
  const { countries, regions, isCountryLoading, isRegionLoading } = useSelector(
    (state) => state.others
  );
  const { questionnaire, isLoading } = useSelector(
    (state) => state?.questionnaire
  );

  const [countriesFiltered, setCountriesFiltered] = useState([]);
  const [regionsFiltered, setRegionsFiltered] = useState([]);
  const [state, setState] = useState({
    studyAboradPreference: null,
    regionInterest: null,
    regionPreference: null,
    countryPreference: [],
    urbanPreference: null,
  });

  useEffect(() => {
    if (countries?.length === 0) {
      dispatch(OthersAction.getCountries());
    }
    if (regions?.length === 0) {
      dispatch(OthersAction.getRegions());
    }
  }, [profileData]);

  useEffect(() => {
    const countryNames = countries?.map((country) => ({
      label: country.name,
      value: country.name,
    }));
    setCountriesFiltered(countryNames);
  }, [countries]);

  useEffect(() => {
    const regionNames = regions?.map((region) => ({
      label: region.name,
      value: region.name,
    }));
    setRegionsFiltered(regionNames);
  }, [regions]);

  useEffect(() => {
    setState({
      studyAboradPreference: questionnaire?.studyAboradPreference ?? null,
      regionInterest: questionnaire?.regionInterest ?? null,
      regionPreference: questionnaire?.regionPreference ?? null,
      countryPreference: questionnaire?.countryPreference ?? [],
      urbanPreference: questionnaire?.urbanPreference ?? null,
    });
  }, [questionnaire]);

  const handleNext = () => {
    if (
      !state.studyAboradPreference ||
      !state.regionInterest ||
      !state.regionPreference ||
      state.countryPreference?.length === 0 ||
      !state?.urbanPreference
    ) {
      message.error("Please fill all the fields.");
    } else {
      const payload = { userId: profileData?.id, ...state };

      dispatch(
        QuestionnaireAction.addQuestionnaire(payload, (res) => {
          if (res.status === 200) {
            setPage("Financial");
          }
        })
      );
    }
  };

  return (
    <div className="text-black">
      {isLoading || isCountryLoading || isRegionLoading ? (
        <Loader.Circular />
      ) : (
        <div>
          <div className="section-input-title flex justify-between">
            <questionnaireComponents.QuestionnaireLabel
              text="1. How important is it for you to study abroad?"
              required
            />
            <span className="text-[0.875em] text-grayText opacity-60 flex gap-2">
              <span>(least important 1,</span>
              <span>important 3,</span> most important 5)
            </span>
          </div>
          <Spacer height={10} />
          <questionnaireComponents.QuestionnaireCircleInput
            value={state?.studyAboradPreference}
            handleChange={(e) =>
              setState({ ...state, studyAboradPreference: e })
            }
          />
          <Spacer height={24} />

          <questionnaireComponents.QuestionnaireLabel
            required
            text="2. Do you know which country or region you're interested to study in?"
          />
          <Spacer height={10} />
          <div className="pl-3">
            <inputFields.HorizontalRadio
              onChange={(e) =>
                setState({ ...state, regionInterest: e.target.value })
              }
              value={state.regionInterest}
              items={[
                { label: "Yes", value: "yes" },
                { label: "No", value: "no" },
              ]}
            />
          </div>
          <Spacer height={24} />

          <questionnaireComponents.QuestionnaireLabel
            required
            text="3. What region do you prefer?"
          />
          <Spacer height={5} />
          <div className="w-[500px]">
            <inputFields.SelectDropdown
              style={{ width: "50%", paddingLeft: "12px" }}
              onChange={(e) => setState({ ...state, regionPreference: e })}
              placeholder="Search here"
              value={state?.regionPreference}
              items={regionsFiltered}
            />
          </div>
          <Spacer height={24} />

          <questionnaireComponents.QuestionnaireLabel
            required
            text="4. What are your top 3 countries of choice?"
          />
          <Spacer height={5} />
          <div className="w-[500px]">
            <inputFields.SelectDropdownMultiple
              style={{ width: "50%", paddingLeft: "12px" }}
              onChange={(e) => {
                if (e.length <= 3) {
                  setState({ ...state, countryPreference: e });
                }
              }}
              placeholder="Search here"
              value={state?.countryPreference}
              items={countriesFiltered}
            />
          </div>
          <Spacer height={24} />
          <questionnaireComponents.QuestionnaireLabel
            required
            text="5. How important is it for you to study in a university located in an
                  urban area?"
          />
          <Spacer height={10} />
          <questionnaireComponents.QuestionnaireCircleInput
            value={state?.urbanPreference}
            handleChange={(e) => setState({ ...state, urbanPreference: e })}
          />

          <Spacer height={24} />
          <div className="flex justify-end">
            <Buttons.DefaultButton onClick={handleNext} size="medium">
              Next
            </Buttons.DefaultButton>
          </div>
        </div>
      )}
    </div>
  );
};

export default Location;
